module.exports = __webpack_public_path__ + "static/img/banner_machine_bg.d1b84e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/home/imgs/head-banner/banner_machine_bg.jpg
// module id = 7Q9x
// module chunks = 0